// emailService.js
import api from '../services/api';

/**
 * Sends AWN creation email notification to Head of Operations only.
 * Fetches the recipient dynamically from the backend.
 */
export const sendEmailNotification = async (awnDetails) => {
  // Fetch the Head of Operations email from backend
  let headOfOpsEmail;
  try {
    const response = await api.get('api/users/head-of-operations-email/');
    headOfOpsEmail = response.data.email;
    if (!headOfOpsEmail) {
      console.warn('No Head of Operations email found, skipping AWN email notification.');
      return;
    }
  } catch (err) {
    console.error('Failed to fetch Head of Operations email:', err);
    return;
  }

  const emailHtml = `
    <div style="font-family: Arial, sans-serif; color: #333; max-width:500px; margin:0 auto; border:1px solid #ddd; border-radius:8px; overflow:hidden;">
      <div style="background-color:rgb(3, 58, 76); padding: 20px; text-align: center; color: #fff;">
        <h1 style="margin: 0; font-size: 22px;">4SIGHT OPERATIONS</h1>
      </div>
      <div style="padding: 24px;">
        <h2 style="margin-top:0;">AWN Entry Created</h2>
        <p>A new AWN entry has been created for project <strong>${awnDetails.projectName}</strong>.</p>
        <p><strong>Job Number:</strong> ${awnDetails.jobNumber}</p>
        <p>Please review and assign resources as needed.</p>
      </div>
      <div style="background-color:rgb(3, 58, 76); padding: 12px; text-align: center; color: #aaa; font-size: 12px;">
        4Sight Operations System
      </div>
    </div>
  `;

  const emailPayload = {
    from: '4SIGHT OPERATIONS <no-reply@4sightoperations.com>',
    to: headOfOpsEmail,
    subject: `AWN Created: ${awnDetails.projectName} (${awnDetails.jobNumber})`,
    html: emailHtml,
    attachments: awnDetails.awnAttachment
      ? [
          {
            filename: `4SiGHT_Analysis_Warning Note_${awnDetails.projectName}.xlsx`,
            content: awnDetails.awnAttachment,
            encoding: 'base64'
          }
        ]
      : []
  };

  return api.post('api/awn/send-email', emailPayload)
    .then((response) => {
      console.log('AWN email sent to Head of Operations:', headOfOpsEmail);
      return response.data;
    })
    .catch((error) => {
      console.error('Failed to send AWN email:', error);
      throw error;
    });
};
